<template>
  <div class="selection" v-if="selectedCount">
    <div class="selection__deselect-all mr-1 ml-4" @click="onDeselectAll">
      <i class="far fa-times-circle"></i>
    </div>
    <div class="selection__counter bold mr-3">
      Selected: {{ selectedCount }}
    </div>
    <div class="selection__action">
      <select class="form-control" @change="onActionSelect">
        <option v-for="option in filteredOptions" :value="option.value">{{ option.label }}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        selectedCount: 0,
        filteredOptions: [],
        options: [
          {
            label: 'Select action',
            value: 0,
            simpleUserAccess: true
          },
          {
            label: 'Bill',
            event: 'selection.bill',
            value: 1,
            simpleUserAccess: true
          },
          {
            label: 'Confirm',
            event: 'selection.confirm',
            value: 2,
            simpleUserAccess: false
          }
        ]
      }
    },

    created() {
      this.filteredOptions = this.options.filter(option => (option.simpleUserAccess || !this.isSimple()))
      this.$root.$on('selection.taskSelected', this.onTaskSelected)
      this.$root.$on('selection.taskDeselected', this.onTaskDeselected)
      this.$root.$on('selection.actionCompleted', this.onDeselectAll)
    },

    methods: {
      ...mapGetters('auth', ['isSimple']),
      onTaskSelected() {
        this.selectedCount++
      },

      onTaskDeselected() {
        if (this.selectedCount > 0)
          this.selectedCount--
      },

      onActionSelect(event) {
        const value = this.getValueFromSelectEvent(event)
        const e = this.getSelectedValueEvent(value)

        if (e)
          this.$root.$emit(e)
      },

      onDeselectAll(event) {
        this.selectedCount = 0
        this.$root.$emit('selection.deselectAll')
      },

      getValueFromSelectEvent(event) {
        if(event.target.options.selectedIndex > -1) {
          return event.target.options[event.target.options.selectedIndex].value
        }
      },

      getSelectedValueEvent(value) {
        const option = this.filteredOptions.find(option => option.value === parseInt(value))
        if (option)
          return option.event

        return null
      }
    }
  }
</script>

<style scoped>

  .selection__action select {
    min-width: 120px;
  }

  .selection__deselect-all .far {
    font-size: 1.5rem;
    cursor: pointer;
  }

  .selection {
    display: flex;
    align-items: center;
    min-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/Selection.vue